import { SkillBranchDict } from "../../../../model/Dto/Dict/Skill";
import { ApiRequest, RequestMethod } from "../../../request";

export async function getAllSkillBranches(): Promise<SkillBranchDict[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl("/api/skill-branch");
    const response: any = await apiRequest.send();
    return response.data ?? [];
}
